import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../../../getFulfilmentType";

const DEFAULT_SOURCE = "primary";
const DEFAULT_SELLER = "asos";

const getAFSEvars = ({ sourceId, sellerId }) => {
  if (getFulfilmentType({ sourceId, sellerId }) !== FULFILMENT_TYPE.AFS) {
    return [];
  }

  return [
    `eVar211=afs - ${sourceId || DEFAULT_SOURCE}`,
    `eVar215=afs - ${sellerId || DEFAULT_SELLER}`
  ];
};

export default getAFSEvars;
